<template>
  <section
    v-if="product && ratio > recommendationRateThreshold || !reviewsCount"
    :aria-label="$t.reviews"
    class="mx-a p-6 gap-8 grid cols-1 lg:pb-15 lg:gap-20"
    :class="reviewsCount && fitRatings.length ? 'lg:cols-2' : 'cols-1'"
    style="max-width: 55rem"
  >
    <base-lazy-load>
      <div class="text-center">
        <div v-if="ratio > recommendationRateThreshold">
          <h2 class="body-2">
            {{ reviewsCount > 0 ? $t.reviews : $t.reviewsNone }}
          </h2>
          <div class="mt-2 gap-2 inline-grid cols-2 space-y-2 lg:gap-8">
            <div>
              <p v-if="rollup.averageRating">
                <span class="display-1">{{ rollup.averageRating }}</span>
                <span class="title-2">/5</span>
              </p>
              <vf-rating v-if="rollup.averageRating" class="mx-a lg:hidden" :value="rollup.averageRating" />
              <vf-rating
                v-if="rollup.averageRating"
                class="mx-a <lg:hidden"
                size="sm"
                :value="rollup.averageRating"
              />
            </div>
            <div>
              <span class="display-1">{{ ratio }}%</span>
              <p class="body-4">
                {{ $t.customerRecommended }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="!reviewsCount" class="mt-2 center space-y-2">
          <p aria-hidden="true" class="title-1">
            <span>-</span>
            <span>/-</span>
          </p>
          <base-button class="subtitle-5 underlined" @click="openWriteReview">
            {{ $t.reviewsBeTheFirst }}
          </base-button>
        </div>
        <div v-else class="mt-4 lg:mt-6">
          <vf-button @click="openReviews">
            {{ replaceAll($pluralize($t.numberOfReviews, reviewsCount), { reviewsCount }) }}
          </vf-button>
        </div>
        <panel-reviews />
        <panel-review-write />
      </div>
      <product-reviews-fit-rating v-if="fitRatings.length" :fit-ratings="fitRatings" />
    </base-lazy-load>
  </section>
</template>

<script setup lang="ts">
import type { ProductReviewsRollup } from '#root/api/clients/product/data-contracts'

const { $gtm } = useNuxtApp()
const { recommendationRateThreshold } = useAppConfig().pages.pdp.reviews
const { product, reviewsData } = usePdp()

const rollup = computed(() => reviewsData.value?.rollup || {} as ProductReviewsRollup)
const ratio = computed(() => Math.round((rollup.value.recommendedRatio || 0) * 100))
const reviewsCount = computed(() => rollup.value.reviewCount || 0)
const fitRatings = computed(() => rollup.value?.properties?.filter(({ display_type }) => display_type === 'histogram') || [])

const PanelReviewWrite = createPanel('review-write')
const PanelReviews = createPanel('reviews')

const openReviews = () => {
  $gtm.push('pdpPage.onViewReviews')
  PanelReviews.open()
}

const openWriteReview = () => {
  $gtm.push('pdpPage.onWriteReview')
  PanelReviewWrite.open({
    pageId: reviewsData.value?.reviewsPageId || reviewsData?.value?.pageId,
    productId: product.value?.id!
  })
}
</script>
